import { Box } from 'src/components/Box';
import { LogoImage } from 'src/shared/LogoImage';

import type { Appointment } from 'src/models/appointment/_types';

interface Props {
  appointment: Appointment;
  height?: number | string;
  width: number | string;
}
export const AppointmentImage: React.FC<Props> = ({
  appointment,
  height,
  width,
}) => {
  if (appointment.service.thumbnail) {
    return (
      <Box
        component="img"
        src={appointment.service.largeThumbnail}
        sx={{
          borderRadius: 1, // Use '50%' for a circular image, or use a specific value for rounded corners
          height: height, // Adjust the height as needed
          width: width,
        }}
      />
    );
  }

  return <LogoImage height={height} width={width} />;
};
